<template>
    <div class="mobile_screen">
        <div class="big_cat_screen">
            <HeaderNav v-if="!isWeixinBrowser()" navtitle="1000 听力词汇" :beforecolor="'#000'" :backcolor="'#fff'"
                       :showRight="'1'" @returnBack="goToBack" @goRight="goRight"/>
            <div class="imgLazyLoadHead">
                <img v-bind:src="getheadImage()"/>
                <div class="entry course_intro"><div class="entry_back" @click="courseIntroClick"><span>课程介绍 ></span></div></div>
<!--                <div class="can_buy" v-if="isAppIos() && objBigCatHomeInfo.isBuy !== 1"><span>去购买</span></div>-->
                <div class="entry faq"><div class="entry_back" @click="faqClick"><span>家长指导 ></span></div></div>
                <div class="entry contact_master"><div class="entry_back" @click="contactClick"><span>联系班主任 ></span></div></div>
            </div>
            <div class="page-navbar">
                <mt-navbar class="page-part" v-model="selected">
                    <mt-tab-item id="1" :style="parseInt(selected) === 1 ? isSelected(courseId) : {cursor: 'pointer'}">课程列表</mt-tab-item>
                    <mt-tab-item id="2" :style="parseInt(selected) === 2 ? isSelected(courseId) : {cursor: 'pointer'}">词汇表</mt-tab-item>
                    <mt-tab-item id="3" :style="parseInt(selected) === 3 ? isSelected(courseId) : {cursor: 'pointer'}">磨耳朵</mt-tab-item>
                </mt-navbar>
                <div class="sty_tab_container">
                    <mt-tab-container v-model="selected" :style="{backgroundColor:getProgramCourseBGColor(courseId2)}">
                        <mt-tab-container-item id="1">
                            <div class="course_list_content" v-bind:style="{backgroundColor:getProgramCourseBGColor(courseId2)}">
                                <div class="program_achieve" v-if="objBigCatHomeInfo.isBuy === 1">
                                    <div class="program_process" @click="programProcessClick">
                                        <img src="@/Images/icon_canlendar.png" alt="" />
                                        <div class="course_summary">
                                            <span>学习成就</span>
                                            <div class="summary">课程{{objBigCatHomeInfo.finishLessonCount}} · 词汇量{{objBigCatHomeInfo.wordCount}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="home_toolbar" :style="{paddingTop:objBigCatHomeInfo.isBuy === 1 ? '110px' : '40px'}">
                                    <div :class="{'home_toolbar_item':true}" @click="selectUnitClick(0)">
                                        <div :class="{'toolbar_item_selected':tabId === 0}">全部</div></div>
                                    <div :class="{'home_toolbar_item':true}" @click="selectUnitClick(1)">
                                        <div :class="{'toolbar_item_selected':tabId === 1}">L1 - L30</div></div>
                                    <div :class="{'home_toolbar_item':true}" @click="selectUnitClick(2)">
                                        <div :class="{'toolbar_item_selected':tabId === 2}">L31 - L60</div></div>
                                    <div :class="{'home_toolbar_item':true}" @click="selectUnitClick(3)">
                                        <div :class="{'toolbar_item_selected':tabId === 3}">L61 - L90</div></div>
                                    <div :class="{'home_toolbar_item':true}" @click="selectUnitClick(4)">
                                        <div :class="{'toolbar_item_selected':tabId === 4}">L91 - L120</div></div>
                                </div>
                                <div v-for="(itemGroup, indexGroup) in objBigCatHomeInfo.groupLessonArray" :key="indexGroup">
                                    <div class="course_list_title" style="padding-top: 40px">{{"Unit" + itemGroup.week + "：" + itemGroup.englishName}}</div>
                                    <div class="course_list_des">{{itemGroup.chineseName}}</div>
                                    <ul class="lesson_list">
                                        <li v-for="(itemLesson, indexLesson) in itemGroup.lessonArray" :key="indexLesson"
                                            @click="lessonClick(itemLesson.type, itemLesson.pk, itemLesson.audioPackageId)">
                                            <div class="lesson_item_left">
                                                <img :src="$qiNiuDomainBase + itemLesson.picture"/>
                                            </div>
                                            <div class="lesson_item_center">
                                                <div class="name">{{itemLesson.name}}</div>
                                                <div class="des_text" v-if="!isEmpty(itemLesson.subject)">主题：{{itemLesson.subject}}</div>
                                                <div class="des_text" v-if="!isEmpty(itemLesson.coreWords)">词汇：{{itemLesson.coreWords}}</div>
                                                <div class="des_text" v-if="itemLesson.wordCount > 0">累积词汇：{{itemLesson.wordCount}}/1000</div>
                                                <div class="des_text" v-if="itemLesson.type === 3">{{itemLesson.description}}</div>
                                                <div class="des_text" v-if="itemLesson.type === 0">选择本周喜欢的一本重复</div>
                                                <div class="des_text" v-if="itemLesson.type === 0">本周核心词汇小游戏</div>
                                            </div>
                                            <div class="lesson_item_right">
                                                <img class="img2" v-if="getCount(itemLesson.finish) === 1" src="@/assets/240_course_finished.png" height="48"
                                                     width="60"/>
                                            </div>
                                            <div class="clear"></div>
                                            <div v-if="objBigCatHomeInfo.isBuy === 0 && getCount(itemLesson.freeTrial) === 1" class="try_listen">试听练一练</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="lesson_list_bottom"></div>
                            </div>
                            <div class="new_hint"><img src="@/Images/new_course_hint.png"></div>
                            <div class="new_hint_content">共120课, 每周更新～</div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id="2">
                            <div :style="{backgroundColor:getProgramCourseWordColor(courseId2), marginBottom:'80px'}">
                                <div class="Words_glossary_item" v-for="(item,index) in WordsGlossaryArray" :key="index">
                                    <div :id="'section_' + item.initial" :style="{'padding-top':(44 + getStatusHeight())+'px', 'margin-top': '-'+(44 + getStatusHeight())+'px'}">
                                        <div class="section_title">{{item.initial}}</div>
                                    </div>
                                    <div class="Words_glossary_wordsitem" v-for="(section,index) in item.sections" :key="index"
                                         @click="wordClick(section.youdaoUrl, section.pk, section.word)">
                                        <div class="Word">
                                            {{section.word}}
                                            <span v-if="getCount(section.subscript) > 0">{{getCount(section.subscript)}}</span>
                                        </div>
                                        <div class="point">···············</div>
                                        <div class="lesson_name">{{section.code}}</div>
                                        <div class="clear"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="Words_glossary_indexs">
                                <div class="Words_glossary_indexsitem" v-for="(item,index) in WordsGlossaryArray" :key="index"
                                     @click="scrollToPositin(item.initial)">
                                    {{item.initial}}
                                </div>
                            </div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id="3">
                            <div class="package_list" :style="{backgroundColor:getProgramCourseBGColor(courseId2), marginBottom:'80px'}">
                                <li v-for="(itemPackage, indexPackage) in listPackage" :key="indexPackage"
                                    @click="packageClick(itemPackage.pk)">
                                    <div>
                                        <div class="package_item_left">
                                            <img src="@/Images/folder_audio.png" />
                                        </div>
                                        <div class="package_item_right">
                                            <div class="name">
                                                {{itemPackage.title}}
                                            </div>
                                            <div class="count"><img src="@/Images/cell_audio_set.png" /><span>{{itemPackage.audioCount}}集</span></div>
                                        </div>
                                        <div class="clear"></div>
                                        <div class="line"></div>
                                    </div>
                                </li>
                            </div>
                        </mt-tab-container-item>
                    </mt-tab-container>
                </div>
            </div>
            <!-- !isAppIos() && -->
            <div class="bottom_tool" v-if="objBigCatHomeInfo.isBuy === 0" :style="{height: adapterBigScreenHeight()}">
                <div class="tabbar_buy" :style="{marginBottom: judgeBigScreen() ? '36px' : '0'}" @click="buyProgram">
                    <span>购买课程</span>
                    <div class="go">立即前往</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {MessageBox} from "mint-ui";
    import Vue from 'vue'
    import Utils from '@/pages/Program/util2.js';

    export default {
        data() {
            return {
                selected: '1',
                courseId: parseInt(this.$route.query.courseId),
                courseId2: 0,
                objBigCatHomeInfo: {},
                totalPartCount: 4,
                WordsGlossaryArray: [],
                listPackage: [],
                objExperience: {},
                tabId: 0
            }
        },
        methods: {
            goRight:function() {
                this.$router.push({name: "PShareAward", query: {}});
            },
            selectUnitClick: function (tabId) {
                let that = this;

                if (that.tabId === tabId) {
                    return;
                }

                that.tabId = tabId;
                let url = "englishProgram/getHomeLesson/" + tabId;

                that.$axios.get(url).then((response) => {
                    that.objBigCatHomeInfo.groupLessonArray = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            adapterBigScreenHeight: function () {
                return this.judgeBigScreen() ? "96px" : "60px";
            },
            judgeBigScreen: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return false;
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值
                return rate > limit;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            buyProgram: function () {
                let that = this;
                let vPlatform = that.judgePlatform();
                let vYouZanUrl = this.objBigCatHomeInfo.buyUrl.replace(new RegExp('https:','g'), '');

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:buyProgramCourse:" + that.courseId + ":" + vYouZanUrl;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.buyProgramCourse(that.courseId, that.objBigCatHomeInfo.buyUrl);
                }
            },
            buyCourseSuccess: function () {
                let that = this;
                that.objBigCatHomeInfo.isBuy = 1;
            },
            courseIntroClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewCourseIntro:" + that.objBigCatHomeInfo.articleId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewCourseIntro(that.objBigCatHomeInfo.articleId);
                }
            },
            faqClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewFaq:" + that.courseId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewFaq(that.courseId);
                }
            },
            contactClick: function () {
                this.$router.push({name: "PHeadmaster", query: {}});
            },
            programProcessClick: function() {
                this.$router.push({name: 'PAchieve', query: {}});
            },
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        document.location = "readingclubapp:gobackMyCourse";
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    this.goBack(this.$router);
                }
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            },
            showStatusWhite:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.changeStatusStyle(status);
                }
            },
            getheadImage:function(){
                return require('@/Images/program_head.png');
            },
            lessonClick: function (type, pk, audioPackageId) {
                // 复习
                if (type === 0) {
                    let that = this;

                    if (that.objBigCatHomeInfo.isBuy === 0) {
                        MessageBox.confirm('', {
                            message: ' ',
                            title: '要先购买才能上课哦～快去购买吧！',
                            showConfirmButton:false,
                            showCancelButton:true,
                            closeOnClickModal: false,
                            cancelButtonClass:'cancelButton',
                            confirmButtonClass:'confirmButton',
                            cancelButtonText:'知道了'
                        });
                        return;
                    }

                    this.$router.push({
                        name: 'PReview',
                        query: {lessonId: pk}
                    });

                    return;
                }

                // 磨耳朵
                if (type === 3) {
                    this.packageClick(audioPackageId);
                    return;
                }

                this.$router.push({
                    name: 'PLesson',
                    query: {courseId: this.courseId, lessonId: pk}
                });
            },
            wordClick: function (youdaoUrl, wordId, word) {
                if (!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                } else {
                    this.$router.push({
                        name: 'PCard', query: {courseId: this.courseId, wordId: wordId, word: word}
                    });
                }
            },
            packageClick: function(pk) {
                if (this.isAppIos()) {
                    document.location = "readingclubapp:singleAudioPackage:" + pk;
                }

                if (this.isAppAndroid()) {
                    window.note.singleAudioPackage(pk);
                }
            },
            isSelected(id) {
                return {
                    color: this.getProgramCourseColor(id),
                    'border-bottom': '3px solid ' + this.getProgramCourseColor(id),
                    cursor: 'pointer'
                };
            },
            getFirstLettersArray(array) {
                let firstLetters = [];

                array.forEach(item => {
                    if (firstLetters.indexOf(item.firstLetter) === -1) {
                        firstLetters.push(item.firstLetter);
                    }
                });

                return firstLetters;
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            },
            readyPage:function () {
                var divWidth = parseInt($(".page").css("width").replace("px", ""));

                $('.ck-editor-content .lazy').each(function () {
                    var imgWidth = parseInt($(this).attr("data-w")); // 图片最大宽度
                    var imgRatio = parseFloat($(this).attr("data-ratio"));  // 缩放比例
                    var imgHeight = 0;  // 图片实际高度

                    if (divWidth > imgWidth) {
                        if (imgWidth > divWidth - 30) {
                            imgWidth = divWidth - 30;
                        }
                        imgHeight = parseInt(imgWidth * imgRatio);
                    } else {
                        imgWidth = divWidth - 30;
                        imgHeight = parseInt(imgWidth * imgRatio);
                    }

                    window.console.log(imgWidth);
                    window.console.log(imgHeight);

                    $(this).attr("style", "height:" + imgHeight + "px;" + "width:" + imgWidth + "px;")
                });

                $(".ck-editor-content .lazy").lazyload({
                    placeholder: "/lazyload/grey.gif"
                });

                $(".ck-editor-content img").each(function (idex, item) {
                    var vSrc = $(item).attr("src");

                    if (vSrc.indexOf("/lazyload/grey.gif") !== -1) {
                        vSrc = $(item).attr("data-original");
                    }
                });
            },
            setLessonFinish: function (lessonId) {
                let that = this;

                that.objBigCatHomeInfo.groupLessonArray.forEach((groupItem, groupIndex) => {
                    groupItem.lessonArray.forEach((lessonItem, lessonIndex) => {
                        if (lessonItem.pk === lessonId) {
                            lessonItem.finish = 1;
                            Vue.set(groupItem.lessonArray, lessonIndex, lessonItem);
                        }
                    });
                });
            },
        },
        created() {
            let that = this;

            // 客户端调用方法组
            window.buyCourseSuccess = that.buyCourseSuccess;
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let url = "englishProgram/getHomeInfo3";

            that.$axios.get(url).then((response) => {
                that.objBigCatHomeInfo = response.data;
                that.courseId = vCourseId;
                that.courseId2 = vCourseId;
            }).catch(function (error) {
                window.console.log(error)
            });

            let url2 = "englishProgram/getGlossary/" + vCourseId;

            that.$axios.get(url2).then((response) => {
                let wordsGlossarys = response.data;
                let firstLetters = that.getFirstLettersArray(wordsGlossarys);

                firstLetters.forEach(initial => {
                    let sections = wordsGlossarys.filter(wordsGlossary => wordsGlossary.firstLetter === initial);
                    that.WordsGlossaryArray.push({
                        initial,
                        sections
                    });
                })
            }).catch(function (error) {
                window.console.log(error)
            });

            let url3 = "englishProgram/getAudioPackage/" + vCourseId + "/0/1000";
            that.$axios.get(url3).then((response) => {
                that.listPackage = response.data;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {
            let that = this;
            window.BAfterScrollTop = 0;

            Utils.$on('setLessonFinish', function (lessonId) {
                that.setLessonFinish(lessonId);
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, from, next) {
            this.showStatusWhite(1);
            window.BAfterScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.BAfterScrollTop);
        }
    }
</script>
<style scoped>
    .home_toolbar {
        width: calc(100% - 20px);
        text-align: center;
        margin-right: 10px;
        margin-left: 10px;
        display: flex;
        flex-wrap: wrap;
    }
    .home_toolbar_item {
        width: calc((100vmin - 80px)/3.0);
        height: 30px;
        line-height: 30px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: normal;
        color: #333333;
        background-color: white;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .toolbar_item_selected {
        display: inline-block;
        width: calc((100vmin - 80px)/3.0);
        height: 30px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        color: #ff5050;
        border: 1px solid #ff5050;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .course_list_title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        padding-top: 40px;
        margin-left: 30px;
        margin-right: 30px;
    }
    .course_list_des {
        color: #666666;
        font-size: 17px;
        text-align: center;
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 5px;
    }
    .course_list_guidance {
        text-align: center;
    }
    .course_list_guidance .guidance {
        color: #666666;
        font-size: 15px;
        width: 90px;
        text-align: center;
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        display: inline-block;
    }
    .imgLazyLoadHead {
        position: relative;
        padding: 0px;
    }
    .imgLazyLoadHead img {
        display: block;
        width: 100%;
        margin: auto;
    }
    .imgLazyLoadHead .entry {
        width: 33.3vmin;
        position: absolute;
        bottom: 15px;
        display: flex;
        justify-content: center;
    }
    .imgLazyLoadHead .can_buy {
        width: 45px;
        height: 18px;
        line-height: 16px;
        text-align: center;
        position: absolute;
        bottom: 36px;
        left: calc(33.3vmin - 40px);
        background-color: #ff505a;
        border-radius: 9px;
        -webkit-border-radius: 9px;
        -moz-border-radius: 9px;
    }
    .imgLazyLoadHead span {
        color: white;
        font-size: 13px;
    }
    .imgLazyLoadHead .can_buy span {
        color: white;
        font-size: 12px;
        text-align: center;
    }
    .imgLazyLoadHead .entry_back {
        width: 100px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        background-color: #ffffffdb;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }
    .imgLazyLoadHead .entry_back img {
        width: 15px;
        height: 15px;
    }
    .entry_back span {
        color: #333333;
    }
    .imgLazyLoadHead .faq {
        left: 33.3vmin;
    }
    .imgLazyLoadHead .contact_master {
        left: 66.6vmin;
    }

    .course_list_content {
        height: auto;
    }
    .lesson_list {
        position: relative;
    }
    .lesson_list:first-child {
        padding-top: 15px;
    }
    .lesson_list:last-child {
        padding-top: 15px;
    }
    .lesson_list li {
        background-color: white;
        margin: 0px 10px 15px 10px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        padding: 15px;
        position: relative;
    }
    .lesson_list li .lesson_item_left {
        float: left;
        width: 80px;
        height:80px;
    }
    .lesson_list li .lesson_item_left img {
        width: 100%;
    }
    .lesson_list li .lesson_item_center {
        float: left;
        margin-left: 10px;
        width: calc(100% - 110px);
    }
    .lesson_list li .lesson_item_center .name {
        max-width: 100%;
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }
    .lesson_list li .lesson_item_center .des_text {
        text-align: left;
        font-size: 13px;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
    .lesson_list li .lesson_item_center div {

    }
    .lesson_list li .lesson_item_right {
        width: 50px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }
    .lesson_list li .lesson_item_right .img1 {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }
    .lesson_list li .lesson_item_right .img2 {
        position: absolute;
        top: 5px;
        right: 15px;
        -webkit-transform: translateY(5px);
    }
    .lesson_list li .lesson_item_right span {
        position: absolute;
        right: 15px;
        bottom: 15px;
        font-size: 15px;
        color: #999999;
    }

    .package_list {
        margin-bottom: 1px;
    }
    .package_list .line {
        width: 100%;
        height: 1px;
        background-color: #f1f1f1;
    }
    .package_list li {
        background-color: white;
    }
    .package_list li .package_item_left {
        float: left;
        width: 50px;
        height: 50px;
        margin-left: 20px;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .package_list li .package_item_left img {
        width: 100%;
    }
    .package_list li .package_item_right {
        float: left;
        margin-left: 10px;
    }
    .package_list li .package_item_right .name {
        margin-top: 15px;
        font-size: 13pt;
        font-weight: bold;
    }
    .package_list li .package_item_right .count img {
        width: 14px;
        height: 14px;
        margin-top: 2px;
    }
    .package_list li .package_item_right .count span {
        margin-left: 5px;
        font-size: 11pt;
        color: #999999;
    }

    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .lesson_list_bottom {
        height: 50px;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    .Words_glossary_item .section_title {
        background-color: #f4f4f4;
        text-align: left;
        height: 25px;
        font-size: 14px;
        color: #666666;
        line-height: 25px;
        padding-left: 15px;
    }
    .Words_glossary_wordsitem {
        position: relative;
        height: 60px;
    }
    .Words_glossary_wordsitem .Word {
        position: absolute;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        padding: 5px 16px 5px 16px;
        left: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        background-color: white;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }
    .Words_glossary_wordsitem .Word span {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        color: #999999;
        font-weight: normal;
    }
    .Words_glossary_wordsitem .point {
        text-align: center;
        font-size: 14px;
        color: #333;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .Words_glossary_wordsitem .lesson_name {
        position: absolute;
        text-align: left;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        color: #333333;
        font-size: 15px;
    }
    .Words_glossary_indexs {
        position: fixed;
        bottom: 50px;
        right: 0;
        z-index: 999;
    }
    .Words_glossary_indexs .Words_glossary_indexsitem {
        font-size: 10px;
        font-weight: bold;
        color: #333333;
        height: 15px;
        width: 25px;
    }
    .bubbleContainer{
        position: absolute;
        bottom: 0px;
        left: calc(100%/3 + (100%/3 - 120px)/2);
        padding-bottom: 6px;
    }
    .sty_tab_container {
        position: relative;
    }
    .bubbleContainer2{
        position: absolute;
        top: 5px;
        right: 0;
        padding-bottom: 6px;
        z-index: 9999;
    }
    .bubbleContainer .text, .bubbleContainer2 .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 10px 3px 10px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer .img {
        position: absolute;
        bottom: 0;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer2 .img {
        position: absolute;
        top: -12px;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer .img img, .bubbleContainer2 .img img {
        width: 12px;
    }
    .page {
        background-color: white;
        min-height: 70vh;
    }
    .experience_title
    {
        font-size: 25px;
        color: #333333;
        font-weight: bold;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 5px;
        padding-top: 15px;
        text-align: left;
    }
    .content_top {
        height: 30px;
    }
    .content_margin
    {
        margin-left: 15px;
        margin-right: 15px;
        padding-bottom: 85px;
    }
    .span_experience_content {
        text-align: left;
    }
    .ck-editor-content
    {
        color: #333;
        margin-bottom: 20px;
        font: 17px/1.8 "Microsoft YaHei" ,Arial,Helvetica,sans-serif, "宋体";
        letter-spacing:1px;
    }
    .ck-editor-content p
    {
        margin-top:0px;
        margin-bottom:0px;
        word-wrap: break-word;
    }
    .ck-editor-content blockquote {
        overflow: hidden;
        padding-right: 1.5em;
        padding-left: 1.5em;
        margin-left: 0;
        border-left: 5px solid #ccc;
        margin-top:0px;
        margin-bottom:0px;
    }
    .ck-editor-content figcaption
    {
        color: #999;
        font-size: .75em;
        outline-offset: -1px;
        padding-top: .6em;
        text-align:center;

    }
    .ck-editor-content figure
    {
        padding:0px;
        margin-left:0px;
        margin-right:0px;
        margin-top:10px;
        margin-bottom:10px;
        text-align: center;
    }
    .ck-editor-content figure img
    {
        border:0px;
        max-width: 100%;
    }
    .ck-editor-content >>> .image {
        padding: 0;
        margin: 0;
    }
    .program_achieve {
        width: 100%;
        position: absolute;
        top: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .program_process {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        background-color: #FEF5CB;
        -webkit-box-shadow: #999 0 0 10px;
        -moz-box-shadow: #999 0 0 10px;
        box-shadow: #999 0 0 10px;
    }
    .program_process img {
        width: 40px;
        height: 40px;
        margin-left: 10px;
        margin-right: 5px;
    }
    .program_process span {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-right: 15px;
    }
    .program_process .course_summary {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .program_process .course_summary .summary {
        color: #666666;
        font-size: 13px;
        margin-right: 15px;
    }
    .try_listen {
        position: absolute;
        background-color: red;
        color: white;
        top: 0;
        right: 0;
        font-size: 10px;
        padding: 2px 5px;
        border-top-right-radius: 5px;
        border-bottom-left-radius: 10px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-top-right-radius: 5px;
    }
    .new_hint {
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .new_hint img {
        width: 100px;
        height: 100px;
    }
    .new_hint_content {
        width: 100%;
        display: flex;
        justify-content: center;
        color: #999999;
        font-size: 15px;
        margin-bottom: 135px;
    }
    .bottom_tool {
        position: fixed;
        background-color: #f4f4f4;
        width: 100%;
        z-index: 10000;
        bottom: 0;
        height: 60px;
    }
    .tabbar_buy {
        display: flex;
        height: 60px;
        background-color: #ff505a;
        width: 100%;
        z-index: 10000;
        align-items: center;
        justify-content: center;
    }
    .tabbar_buy span {
        color: white;
        font-size: 17px;
        text-align: center;

    }
    .tabbar_buy .go {
        position: absolute;
        height: 26px;
        line-height: 26px;
        right: 15px;
        background-color: white;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px;
        color: #ff505a;
        text-align: center;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }

</style>
